import { Column } from 'src/components/custom_components/CustomTable/CustomTable';

export const getColumnKey = <T>(column: Column<T>): string =>
  (column.key ?? column.dataIndex) as string;
